import axios from 'axios';
//---
const axiosInstant= axios.create();
axiosInstant.interceptors.request.use(function (config) {
    if(!config?.data){
        delete config.headers['Content-Length'];
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});
axiosInstant.interceptors.response.use(function (response) {
    // console.info('interceptors.request response::', response);
    if (response?.data == "" || response?.data?.result == 'TOKEN_EXPIRED') {
        localStorage.removeItem('ncc_Token');
        // localStorage.removeItem('ncc_TokenExpiration');
        window.location.href = "/tokenverifyExpire?expirepath=" + window.location.pathname;
    }
    else if (response?.data == "" || response?.data?.result == 'TOKEN_INVALID') {
        localStorage.removeItem('ncc_Token');
        // localStorage.removeItem('ncc_TokenExpiration');
        window.location.href = "/tokenverifyInvalid?expirepath=" + window.location.pathname;
    }
    return response;
}, function (error) {
    if (error?.response) {
        console.error(`interceptors.response.error status:${error.response.status},statusText:${error.response.statusText}:: detail error.response::`, error.response);
    } else {
        console.error('interceptors.response.error error.message::', error.message);
    }
    return Promise.reject(error);
});
export default axiosInstant;